import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import { ArrowLeft } from 'lucide-react'
import { PropsWithChildren } from 'react'
import { Link } from '@/i18n/navigation'

type BackButtonProps = {
  href: string
  showIcon?: boolean
  iconPosition?: 'left' | 'right'
  label: string
}

export const BackButton = (props: PropsWithChildren<BackButtonProps>) => {
  const { href, showIcon = true, iconPosition, label } = props

  return (
    <Link href={href}>
      <Button
        variant="ghost"
        size="sm"
        className={cn('flex items-center', {
          'flex-row-reverse': iconPosition === 'right',
        })}
      >
        {showIcon && <ArrowLeft className="h-4 w-4 mr-2" />}
        <span>{label}</span>
      </Button>
    </Link>
  )
}
